<template>
  <section>

    <div
      class="modal-card"
      style="width: auto; z-index: 10000; position: relative"
    >

      <header class="modal-card-head">
        <div class="title is-bold">Rent Comps
          <img
            style="margin-left: 1em"
            src="@/assets/rr_logo.png"
            width="100px"
          >
        </div>
      </header>

      <section class="modal-card-body">

        <div class="subtitle is-bold">Recently rented units similiar to your subject property</div>

        <div class="subtitle">Instructions: exclude rent comps that are outliers then click 'Apply'</div>

        <section
          v-for="rentComp in $store.state.rentComps"
          :key="rentComp.calculatedRentValue"
          style="margin-bottom: 2em;margin-top: 2em"
        >
          <nav
            class="level"
            style="margin-bottom: .5em"
          >

            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Beds-Baths</p>
                <p class="subtitle">{{ rentComp.beds }}-{{ rentComp.baths }}</p>
              </div>
            </div>

            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Sqft</p>
                <p class="subtitle">{{ rentComp.sqft | number(0) }}</p>
              </div>
            </div>

            <div class="level-item has-text-centered">
              <div>
                <p class="heading"></p>
                <p class="subtitle">x</p>
              </div>
            </div>

            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Average $/sqft</p>
                <p class="subtitle">{{ rentComp.averagePricePerSqft | currency(2) }}</p>
              </div>
            </div>

            <div class="level-item has-text-centered">
              <div>
                <p class="heading"></p>
                <p class="subtitle">=</p>
              </div>
            </div>

            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Calculated Rent Price</p>
                <p class="subtitle">{{ rentComp.calculatedRentValue | currency(0) }}</p>
              </div>
            </div>

          </nav>

          <table class="is-narrow is-fullwidth">
            <tr>
              <td class="align-left">Address</td>
              <td class="align-center">Beds</td>
              <td class="align-center">Baths</td>
              <td class="align-center">Sqft</td>
              <td class="align-center">Miles</td>
              <td class="align-center">Rent</td>
              <td class="align-center">$/sqft</td>
              <td class="align-center">Recorded</td>
              <td class="align-center">Include?</td>
            </tr>
            <tr
              v-for="comp in rentComp.comp"
              :key="comp.address"
              :class="{ 'is-excluded': !comp.include }"
            >
              <td
                class="align-left"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.address }}, {{ comp.zipcode }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.beds }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.baths }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.sqft | number(0) }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.dist | number(1) }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.rent | currency(0) }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.rent / comp.sqft | currency(2) }}</td>
              <td
                class="align-center"
                :style="{ 'text-decoration': isStrikeThrough(!comp.include) }"
              >{{ comp.recordingDate | fromNow }}</td>
              <td class="align-center">
                <div @change="calculate(rentComp, comp, !comp.include)">
                  <b-checkbox v-model="comp.include"></b-checkbox>
                </div>
              </td>
            </tr>
          </table>
        </section>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { applyToScheduledRents(); $parent.close() }"
        >Apply</button>
      </footer>

    </div>

  </section>
</template>

<script>
export default {
  props: {
    propertyId: {
      type: String,
      required: true
    },
    rents: {
      type: Array,
      required: true
    },
    inputsRents: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      errorMessage: "",
      internalAddress: ""
    };
  },

  watch: {},

  methods: {
    cancel() {},

    async calculate(rentComp, comp, include) {
      comp.include = include;
      let includedComps = rentComp.comp.filter(
        c => c.include == true && c.sqft > 0
      );
      let sumRentPerSqft = includedComps
        .map(c => c.rent / c.sqft)
        .reduce((a, b) => a + b, 0);
      if (includedComps.length > 0)
        rentComp.averagePricePerSqft = sumRentPerSqft / includedComps.length;
      else rentComp.averagePricePerSqft = 0;

      // Do the calculation.
      rentComp.calculatedRentValue =
        rentComp.sqft * rentComp.averagePricePerSqft;
    },

    isStrikeThrough(value) {
      if (value == true) return "line-through";
      else return "";
    },

    isDimmer(value) {
      if (value == true) return "brightness(35%)";
      else return "brightness(100%)";
    },

    applyToScheduledRents() {
      for (let rent of this.$store.state.rentComps) {
        // Get the matching units for rent.
        let type = rent.beds.toString() + "-" + rent.baths.toString();
        let matching = this.inputsRents.find(
          u => u.sqft == rent.sqft && u.type == type
        );
        if (matching) matching.currentRent = rent.calculatedRentValue;
      }
      this.$buefy.toast.open({
        message: `The Scheduled Rents have been updated`,
        type: "is-success",
        duration: 3000
      });
    }
  },

  async mounted() {
    let propertyId = this.propertyId;
    let rents = this.rents;
    let inputsRents = this.inputsRents;

    console.log("TCL: mounted -> propertyId", propertyId);
    console.log("TCL: mounted -> rents", rents);
    console.log("TCL: mounted -> inputsRents", inputsRents);

    if (this.$store.state.rentCompPropertyId != this.propertyId) {
      this.$store.state.rentCompPropertyId = this.propertyId;

      await this.$store
        .dispatch("createRentComps", {
          propertyId,
          rents
        })
        .then(() => {
          // Success.
          console.log("TCL: mounted -> rents", rents);
        })
        .catch(() => {
          // Failure.
        });
    }
  }
};
</script>

<style>
tr.is-excluded {
  background: hsl(0, 0%, 98%);
  color: hsl(0, 0%, 48%);
}
td.align-left {
  text-align: left;
}
td.align-right {
  text-align: right;
}
td.align-center {
  text-align: center;
}
</style>
